import {http} from 'msw';
import {SetupWorker, setupWorker} from 'msw/browser';
import {isLocalHost} from './config';
import {localServices, INTEGRATION_BASE_URL} from '../localServices.config';

let localServiceWorker: SetupWorker | null = null;
let isActive = false;

const start = async () => {
  if (!isLocalHost || isActive) {
    return;
  }

  const enabledServices = Object.entries(localServices).filter(
    ([, config]) => config.enabled,
  );

  if (enabledServices.length === 0) {
    return;
  }

  const handlers = enabledServices.map(([name, config]) => {
    const matchUrl = `${INTEGRATION_BASE_URL}${config.prefix}`;

    return http.all(
      new RegExp(`^${matchUrl.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}`),
      async (input) => {
        const url = new URL(input.request.url);
        const remainingPath = url.pathname.substring(config.prefix.length);
        const localURL = `${config.target}${remainingPath}${url.search}`;
        console.debug(`[${name}] ${url.href} -> ${localURL}`);

        const fetchOptions: RequestInit = {
          method: input.request.method,
          headers: input.request.headers,
        };

        if (
          input.request.method !== 'GET' &&
          input.request.method !== 'HEAD' &&
          input.request.body
        ) {
          const body = await input.request.text();
          fetchOptions.body = body;
        }

        return await fetch(localURL, fetchOptions);
      },
    );
  });

  if (!localServiceWorker) {
    localServiceWorker = setupWorker(...handlers);
  }

  try {
    isActive = true;
    await localServiceWorker.start({
      onUnhandledRequest: 'bypass',
      quiet: true,
    });
  } catch (error) {
    console.error('[LocalServiceOverride] Failed to start:', error);
    isActive = false;
    throw error;
  }
};

const stop = () => {
  if (localServiceWorker && isActive) {
    localServiceWorker.stop();
    isActive = false;
  }
};

export const LocalServiceOverride = {
  start,
  stop,
  isActive: () => isActive,
} as const;

const isDemoMode = () => {
  try {
    return localStorage.getItem('demo_mode') === 'demo';
  } catch {
    return false;
  }
};

// Auto-start on import if not in demo mode
(async () => {
  if (isDemoMode()) {
    return;
  }

  try {
    await start();
  } catch (error) {
    console.warn(
      '[LocalServiceOverride] Failed to auto-start, continuing without local service overrides',
    );
  }
})();
